// Prestige Shop — theme E JS
(function () {
  // Hero slider
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('.slide'));
    var rail = root.parentNode.querySelector('.rail');
    var thumbs = rail ? [].slice.call(rail.querySelectorAll('.th')) : [];
    var i = 0;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    }
    var p = root.querySelector('[data-prev]'), nx = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-go')); }); });
  });

  // Mobile menu
  var mb = document.querySelector('[data-menu]'), dr = document.getElementById('drawer');
  if (mb && dr) mb.addEventListener('click', function () {
    var open = dr.classList.toggle('open');
    mb.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product gallery thumbs (big images preloaded after page load so clicks swap instantly)
  var thPre = [];
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-thumb]').forEach(function (b) { var im = new Image(); im.src = b.getAttribute('data-thumb'); thPre.push(im); });
  });
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('pointerenter', function () { var im = new Image(); im.src = b.getAttribute('data-thumb'); thPre.push(im); }, { once: true });
    b.addEventListener('click', function () {
      var main = document.querySelector('#pdp-main-image img');
      if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-thumb'); }
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  });

  // Variant option change -> reload with matching variant
  var pv = document.getElementById('pdp-variants');
  if (pv) {
    var variants = [];
    try { variants = JSON.parse(pv.textContent); } catch (e) {}
    document.querySelectorAll('.opt input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = [].slice.call(document.querySelectorAll('.opt input:checked')).map(function (x) { return x.value; });
        var v = variants.filter(function (x) { return x.options.join('|') === sel.join('|'); })[0];
        if (v) { var u = new URL(location.href); u.searchParams.set('variant', v.id); location.href = u.toString(); }
      });
    });
  }

  // Quantity steppers
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var v = (parseInt(input.value || '0', 10) || 0) + parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(min, v);
      });
    });
  });
})();

// Bulk-deal buy box: tier cards drive the quantity input; purchase-type cards drive selling_plan
(function () {
  var bb = document.querySelector('[data-bb]');
  if (!bb) return;
  var form = bb.closest('form');
  var qty = form && form.querySelector('input[name="quantity"]');
  var tiers = [].slice.call(bb.querySelectorAll('[data-bb-tier]'));
  var fmtStr = bb.getAttribute('data-money-format') || '${{amount}}';
  var base = parseInt(bb.getAttribute('data-base'), 10) || 0;
  function money(c) {
    var n = (c / 100), s;
    var commas = function (x) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    if (/amount_no_decimals/.test(fmtStr)) s = commas(Math.round(n).toString());
    else if (/amount_with_comma_separator/.test(fmtStr)) s = n.toFixed(2).replace('.', ',');
    else { var parts = n.toFixed(2).split('.'); s = commas(parts[0]) + '.' + parts[1]; }
    return fmtStr.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  // Tiers -> quantity
  tiers.forEach(function (t) {
    t.addEventListener('change', function () { if (t.checked && qty) qty.value = t.value; });
  });
  function syncTier() {
    if (!qty) return;
    var q = parseInt(qty.value, 10) || 1;
    var want = '1';
    tiers.forEach(function (t) { if (parseInt(t.value, 10) <= q) want = t.value; });
    tiers.forEach(function (t) { t.checked = (t.value === want); });
  }
  if (qty) {
    qty.addEventListener('input', syncTier);
    qty.addEventListener('change', syncTier);
    var stepWrap = qty.closest('.qty');
    if (stepWrap) stepWrap.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(syncTier, 0); });
    });
  }

  // Purchase type -> selling_plan (only present when the product has selling plans)
  var planInput = bb.querySelector('[data-bb-plan-input]');
  if (!planInput) return;
  var ptypes = [].slice.call(bb.querySelectorAll('[data-bb-ptype]'));
  var freq = bb.querySelector('[data-bb-freq]');
  var consent = bb.querySelector('[data-bb-consent]');
  var subPrice = bb.querySelector('[data-bb-sub-price]');
  var subWas = bb.querySelector('[data-bb-sub-was]');
  var mainPrice = document.querySelector('[data-pdp-price] > span');
  var mainOrig = mainPrice ? mainPrice.textContent : '';
  function opt() { return freq ? freq.options[freq.selectedIndex] : null; }
  function render() {
    var sel = ptypes.filter(function (r) { return r.checked; })[0];
    var isSub = sel && sel.value === 'sub';
    var o = opt();
    var unit = base;
    if (isSub && o) {
      planInput.value = o.value;
      planInput.disabled = false;
      unit = parseInt(o.getAttribute('data-price'), 10) || base;
    } else {
      planInput.value = '';
      planInput.disabled = true;
    }
    if (o && subPrice) subPrice.textContent = money(parseInt(o.getAttribute('data-price'), 10));
    if (o && subWas) {
      var was = parseInt(o.getAttribute('data-was'), 10) || 0, pr = parseInt(o.getAttribute('data-price'), 10);
      subWas.textContent = was > pr ? money(was) : '';
    }
    if (consent) consent.hidden = !isSub;
    if (mainPrice) mainPrice.textContent = isSub ? money(unit) : mainOrig;
    bb.classList.toggle('bb-is-sub', !!isSub);
    // Tier figures: one-time = bulk % off base; subscription = plan price per unit (bulk % not promised)
    tiers.forEach(function (t) {
      var n = parseInt(t.value, 10), pct = isSub ? 0 : (parseInt(t.getAttribute('data-pct'), 10) || 0);
      var per = unit - Math.floor(unit * pct / 100), full = base * n, total = per * n, saved = full - total;
      var card = t.closest('.bb-card');
      var set = function (sel, txt) { var el = card.querySelector(sel); if (el) el.textContent = txt; };
      set('[data-bb-total]', money(total));
      set('[data-bb-per]', money(per));
      set('[data-bb-full]', money(full));
      set('[data-bb-saved]', money(Math.max(saved, 0)));
      var fullEl = card.querySelector('[data-bb-full]'), saveWrap = card.querySelector('[data-bb-savewrap]');
      if (fullEl) fullEl.hidden = !(saved > 0);
      if (saveWrap) saveWrap.hidden = !(saved > 0);
    });
  }
  ptypes.forEach(function (r) { r.addEventListener('change', render); });
  if (freq) freq.addEventListener('change', function () {
    var sub = ptypes.filter(function (r) { return r.value === 'sub'; })[0];
    if (sub) sub.checked = true;
    render();
  });
  render();
})();

// Look D: quick add to cart (AJAX, falls back to normal form post) + live cart count
(function () {
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.ld-cart').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-quick-add]') || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]') || f.querySelector('button'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (c) {
      setCount(c.item_count);
      document.dispatchEvent(new CustomEvent('lookd:cart-updated', { detail: c }));
      if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); }
      setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); } }, 1800);
    }).catch(function () { f.removeAttribute('data-quick-add'); f.submit(); });
  });
})();

// Look D v2: phone search toggle, product-row arrows, phone gallery counter
(function () {
  var hdr = document.querySelector('.ld-hdr');
  var st = document.querySelector('[data-search-toggle]');
  if (hdr && st) st.addEventListener('click', function () {
    var open = hdr.classList.toggle('s-open');
    st.setAttribute('aria-expanded', open ? 'true' : 'false');
    var q = hdr.querySelector('.ld-search input[type="search"]');
    if (open && q) q.focus();
  });

  document.querySelectorAll('.ld-band').forEach(function (band) {
    var row = band.querySelector('[data-row]');
    if (!row) return;
    var step = function () { return Math.max(row.clientWidth * 0.8, 200); };
    var p = band.querySelector('[data-row-prev]'), n = band.querySelector('[data-row-next]');
    if (p) p.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  var gm = document.getElementById('pdp-main-image'), gn = document.querySelector('[data-gcount-n]');
  if (gm && gn) {
    var t;
    gm.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var ims = gm.querySelectorAll('img');
        var w = ims.length > 1 ? ims[1].offsetLeft - ims[0].offsetLeft : gm.clientWidth;
        gn.textContent = Math.min(ims.length, Math.round(gm.scrollLeft / Math.max(w, 1)) + 1);
      }, 60);
    }, { passive: true });
  }
})();

